import Vue from 'vue';
export default {
    // 引入组件
    MyPcNodes: function() {
        let MyPcNodesObj = {}
        const allViews = require.context('../../components', true, /\.vue$/);
        allViews.keys().forEach(fileName => {
            let comp = allViews(fileName)
            Vue.component(fileName.replace(/.*?\/([A-Za-z0-9]+)\.vue$/, '$1'), comp.default);
            MyPcNodesObj[fileName.replace(/.*?\/([A-Za-z0-9]+)\.vue$/, '$1')] = comp.default;
        })
        return MyPcNodesObj;
    }
}